import "./mbrdiExperience.scss";
import Banner from "../../Common/Banner/Banner";
import data from "./mbrdi.json";
import iconPathURL from "../../Common/iconPath";

export default function MbrdiExperience() {
  const aboutData = data.data;

  return (
    <div className="mbrdi-container">
      <Banner
        imgSrc={iconPathURL("mbrdi/experiences.png")}
        title="The MBRDI Experience"
      />
      <section className="text-container-section col-xs-12 col-sm-12 col-md-12 col-lg-10">
        <div className="img-content">
          <div className="second-content">
            <p className="para-content">{aboutData.p1}</p>
            <p className="para-content">{aboutData.p2}</p>
            <p className="para-content">{aboutData.p3}</p>
          </div>
        </div>
      </section>
    </div>
  );
}
